






















import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import { container } from '../../container';
import { DEPENDENCIES } from '../../container/dependencies.const';
import { ComponentsConfig, EmpathyXConfig, GridItem, TrackClickEvents } from '../../models';
import { CONFIG_GETTERS_KEYS, SEARCH_GETTERS_KEYS, SUBMODULES_PATHS } from '../../store';

@Component({
  computed: {
    ...mapState(SUBMODULES_PATHS.search, ['numFound']),
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components,
      config: CONFIG_GETTERS_KEYS.config,
      resultConfig: CONFIG_GETTERS_KEYS.gridResultConfig
    }),
    ...mapGetters(SUBMODULES_PATHS.search, {
      gridItems: SEARCH_GETTERS_KEYS.gridItems,
      hasResults: SEARCH_GETTERS_KEYS.hasResults
    })
  }
})
export default class ResultsGrid extends Vue {
  private components: ComponentsConfig;
  private config: EmpathyXConfig;

  getTrackingEvents(item: GridItem): TrackClickEvents {
    return this.config.resultsGrid.clickEvents[item.modelName];
  }

  getComponentByNamedModel(item: GridItem) {
    const namedComponents: any = this.components.resultsGrid.gridItem;
    if (namedComponents) {
      return namedComponents[item.modelName] || namedComponents.default;
    }
  }

  get staggerValue(): number {
    const hasUserBackFromPDP = container.get<() => boolean>(DEPENDENCIES.HasUserNavigatedBackFromPDP);
    return !hasUserBackFromPDP() ? this.config.resultsGrid.grid.stagger : 0;
  }
}
